document.addEventListener("DOMContentLoaded", function () {

  if (!document.querySelector("#recently-viewed-products")) return;

  const productHandle = window.location.pathname.split("/products/")[1];

  if (!productHandle) return;

  let viewed = JSON.parse(localStorage.getItem("recentlyViewed")) || [];

  viewed = viewed.filter(handle => handle !== productHandle);

  viewed.unshift(productHandle);

  viewed = viewed.slice(0, 8);

  localStorage.setItem("recentlyViewed", JSON.stringify(viewed));

  const container = document.getElementById("recently-viewed-products");

  viewed.forEach(handle => {

    if (handle === productHandle) return;

    fetch("/products/" + handle + ".js")
      .then(response => response.json())
      .then(product => {

        const image = product.featured_image
          ? product.featured_image
          : "";

        const price = (product.price / 100).toFixed(2);

        container.innerHTML += `
  <a href="/products/${product.handle}" class="recent-product">
    <img src="${image}" alt="${product.title}">
  </a>
`;
      });

  });

});